import { DefaultError, useMutation } from "@tanstack/react-query";
import { createModuleTemplate } from "../api/createModuleTemplate";
import { invalidateActiveModuleTemplateListQuery } from "../queries/useActiveModuleTemplateList";
import { invalidateModuleTemplatePagedListQuery } from "../queries/useModuleTemplatePagedListQuery";
import { ModuleDataToCreate, CardBlockImage } from "../types";

type Params = {
  data: ModuleDataToCreate;
  cardBlockImages: CardBlockImage[];
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const useCreateModuleTemplateMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await createModuleTemplate(
        params.data,
        params.cardBlockImages,
        params.topPrivacyTipsBlockImage,
      );
    },
    onSuccess: () => {
      invalidateModuleTemplatePagedListQuery();
      invalidateActiveModuleTemplateListQuery();
    },
    onError: (e) => {
      console.error("Error occurred when creating module", e);
    },
  });
};
